<template>
            <div>
    <product-list-desktop-bridge v-if="isDesktopListLayout" />
    <product-list-mobile v-else />
    <v-dialog
      v-model="productCardDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="productCardDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("productCard") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <card :product-prop="selectProduct" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
        <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ productListFilterTitle }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-tune-variant</v-icon>
              {{ $t("productFilterStatus") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <v-select
                v-model="productStatus"
                :label="$t('status')"
                :items="productStatusItems"
                dense
                outlined
                multiple
                clearable
                hide-details
                item-value="value"
                item-text="text"
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum((productStatus || []).length - 1) }}
                  </span>
                </template>
              </v-select>
              <v-select
                v-model="inventoryStatus"
                :label="$t('inventoryStatus')"
                :items="inventoryStatusItems"
                dense
                outlined
                clearable
                hide-details
                item-value="value"
                item-text="text"
              />
              <tag v-model="tag" />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-shape-outline</v-icon>
              {{ $t("productEntrepotFilterGroups") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="group"
                :title="$t('main-group')"
                type="productGroup"
                :data="JSON.stringify({ parent: null, type: 'group' })"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="cat1"
                :title="$t('other-group')"
                type="productGroup"
                :data="JSON.stringify({ parent: null, type: 'category' })"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="cat2"
                title="category"
                type="productGroup"
                :data="JSON.stringify({ parent: null, type: 'subcategory' })"
                :multiple="true"
                :filter="true"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-office-building-outline</v-icon>
              {{ $t("sellFilterOrg") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="registerar"
                :title="$t('registerar')"
                type="partners"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="branch"
                title="branch"
                type="branch"
                :filter="true"
                :multiple="true"
              />
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>
              <div class="acf-switch">
                <span class="acf-switch__label">{{ $t("showJustBundle") }}</span>
                <v-switch
                  v-model="bundling"
                  class="acf-switch__control mt-0 pt-0"
                  value="active"
                  color="primary"
                  dense
                  inset
                  hide-details
                  :ripple="false"
                />
              </div>
            </div>
          </section>

          <section v-if="!isMobile && customFieldsPermission" class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-form-textbox</v-icon>
              {{ $t("sellFilterCustom") }}
            </div>
            <custom-field
              v-model="customFields"
              :value="customFields"
              type-prop="productCustomFields"
              :multiple="true"
            />
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                :loading="loading"
                @click="removegroup"
              >
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="700"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="product"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog integrator-->
    <v-dialog
      v-model="uploadIntDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadIntDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="productIntegrator"
            :get-item="uploadDialog"
            @close="uploadIntDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    excel update price dialog-->
    <v-dialog
      v-model="excelUpdatePriceDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="excelUpdatePriceDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="updateFixedPrice"
            :get-item="excelUpdatePriceDialog"
            @close="excelUpdatePriceDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <!-- export integrator excel modal-->
    <export-excel
      ref="refIntegratorExcel"
      :data="integratorExcelItems"
      name="integrator.xlsx"
      worksheet="integrator"
      :total-prop="integratorPageCount"
      :before-generate="getIntegratorPageRows"
      :page-prop="integratorExcelPage"
      style="display: none"
      @getAllRows="getIntegratorAllRows"
    />
    <Confirm ref="confirm" />
  </div>
</template>

<script>
import Task from "../task/task";
import Print from "../../components/general/Print/Index";
import General from "../../../../Mixins/general";
import Upload from "../../components/general/upload/upload";
import Card from "./productCard.vue";
import customField from "../../components/general/customFields/index.vue";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import { reorderPinnedHeaders } from "@/plugins/columnPin/columnPin";
import ProductListDesktopBridge from "./layouts/desktop/ProductListDesktopBridge.vue";
import ProductListMobile from "./layouts/mobile/ProductListMobile.vue";
import ProList from "@/Mixins/proList";
import PrintStudio from "@/modules/print/PrintStudio.vue";
import ProListFrame from "@/components/proList/ProListFrame.vue";
export default {
  name: "ProductList",
  provide() {
    return { productList: this };
  },
  components: {
    ProListFrame,
    PrintStudio,
    ProductListDesktopBridge,
    ProductListMobile,
    Tag: () => import("../../components/general/Tag/tag"),
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    Upload,
    Print,
    customField,
    Card,
    Task,
  },
  mixins: [General, ProList],
  props: ["input", "type", "refId", "mobileShow", "titleProp", "inventoryStatusProp"],
  data: () => ({
    excelItems: [],
    selected: [],
    printHeaders: [],
    pageCount: 1,
    page: 1,
    branch: null,
    customFields: null,
    selectProduct: null,
    inventoryStatus: null,
    inventoryStatusItems: null,
    bundling: null,
    group: null,
    cat1: null,
    cat2: null,
    registerar: null,
    selectedHeaders: [],
    productCardDialog: false,
    uploadDialog: false,
    printDialog: false,
    deletDialog: false,
    showSelect: true,
    filter: false,
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    getVariants: false,
    productId: null,
    taskId: null,
    snakbarText: null,
    excelUpdatePriceDialog: false,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    // Table pagination options. Kept separate from `options` because the
    // General mixin reuses `options` for money formatting and overwrites it
    // (beforeMount / currency watcher), which dropped page/itemsPerPage and
    // broke mobile first-load (sortBy.map crash / no getItems).
    tableOptions: {
      page: 1,
      itemsPerPage: 10,
    },
    headers: null,
    listViewportObserver: null,
    listViewportRaf: null,
    // excelItems: [],
    search: null,
    uploadIntDialog: false,
    integratorExcelItems: [],
    integratorExcelPage: 1,
    integratorPageCount: 1,
    skipIntegratorBeforeGenerate: false,
  }),
  computed: {

    productListFilterTitle() {
      var map = {
        ServiceList: "serviceListFilterTitle",
        VariantsList: "variantsListFilterTitle",
        Variants: "variantsListFilterTitle",
      };
      var key = map[this.$route.name] || "productListFilterTitle";
      return this.$t(key);
    },
    activeFilterChips() {

      var app = this;
      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0;
        return v !== null && v !== undefined && v !== "" && v !== "0" && v !== 0;
      };
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0]);
        if (v && typeof v === "object") return v.name || v.text || v.label || "";
        return typeof v === "number" || typeof v === "string" ? String(v) : "";
      };
      var pick = function (items, v, key) {
        var arr = Array.isArray(v) ? v : [v];
        return arr
          .map(function (x) {
            var f = (items || []).find(function (i) {
              return i.value === x;
            });
            return f ? f[key || "text"] : "";
          })
          .filter(Boolean)
          .join("، ");
      };

      var defs = [
        ["productStatus", app.$t("status"), pick(app.productStatusItems, app.productStatus)],
        ["inventoryStatus", app.$t("inventoryStatus"), pick(app.inventoryStatusItems, app.inventoryStatus)],
        ["tag", app.$t("tag")],
        ["group", app.$t("main-group")],
        ["cat1", app.$t("other-group")],
        ["cat2", app.$t("category")],
        ["registerar", app.$t("registerar")],
        ["branch", app.$t("branch")],
        ["bundling", app.$t("showJustBundle"), app.bundling === "active" ? app.$t("showJustBundle") : ""],
        ["customFields", app.$t("sellFilterCustom")],
      ];
      return defs
        .filter(function (d) {
          return has(app[d[0]]);
        })
        .map(function (d) {
          return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) };
        });
    },
    proListKey() {
      return this.productListColumnPersistKey;
    },
    proListLocked() {
      return this.productListLockedColumns;
    },
    isDesktopListLayout() {
      // Embedded usages (mobileShow) keep the desktop view as before
      if (this.mobileShow) return true;
      return this.$vuetify.breakpoint.width >= 800;
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isDesktopListViewport() {
      return !this.isMobile && !this.mobileShow;
    },
    productListColumnPersistKey() {
      return "product-list-columns-" + (this.$route.name || "ProductList");
    },
    productListLockedColumns() {
      // Fixed sticky block: select + #/actions (no unpin/drag)
      var locked = ["actions"];
      return this.showSelect ? ["__select"].concat(locked) : locked;
    },
    productListColumnPlugins() {
      // show-select inserts a leading checkbox <th>; pad visibleHeaders so
      // pin/resize/drag index mapping stays aligned with thead cells.
      var selectHeader = {
        value: "__select",
        text: "",
        width: 32,
        sortable: false,
        pinned: false,
        originalIndex: -1,
      };
      var visible = this.showSelect
        ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || [];
      return {
        headers: this.headers,
        visibleHeaders: visible,
        locked: this.productListLockedColumns,
        anchor: "actions",
        minWidth: 60,
        persistKey: this.productListColumnPersistKey,
      };
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (
          s.value === "variants_count" &&
          !(app.items || []).some((item) => Number(item.variants_count) > 0)
        ) {
          return false;
        }
        if (app.typeForm === "service") {
          if (s.value === "stock" || s.value === "order_point") {
          } else {
            return app.selectedHeaders.includes(s);
          }
        } else {
          return app.selectedHeaders.includes(s);
        }
      });
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    tableOptions: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.tableOptions?.sortBy?.map(function (value) {
          const index = app.headers?.findIndex((h) => h.value === value);
          if (index > -1) {
          app.sortBy.push(app.headers[index].table);
          }
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers?.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    loading(val) {
      if (!val && this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      }
    },
    isDesktopListViewport(val) {
      if (val) {
        this.$nextTick(() => {
          this.updateDesktopTableHeight();
          this.bindListViewportObserver();
        });
      } else {
        this.unbindListViewportObserver();
        this.tableHeight = window.innerHeight - 245;
      }
    },
  },
  activated() {
    // this.getItems()
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.scheduleDesktopTableHeightUpdate();
      });
    }
  },
  beforeMount() {
    if (
      this.$route.name === "ProductList" ||
      this.$route.name === "VariantsList" ||
      this.$route.name === "Variants"
    ) {
      this.typeForm = "product";
    } else {
      this.typeForm = "service";
    }
    this.getVariants =
      this.$route.name === "VariantsList" || this.$route.name === "Variants";

    if (this.$route.name === "Variants" && this.$route.params.id) {
      this.productId = this.$route.params.id;
    }

    this.headers = [
      {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
      {
        text: this.$t("product-name"),
        sortable: true,
        value: "name",
        table: "products.name",
      },
      {
        text: this.$t("code") + "" + this.$t("product"),
        sortable: true,
        value: "code",
        table: "products.code",
      },
      {
        text: this.$t("displayPriority"),
        sortable: true,
        value: "meta.priority",
        table: "product_meta.priority",
      },
      {
        text: this.$t("productKind"),
        sortable: false,
        value: "kind_id",
        table: "product.kind_id",
      },
      {
        text: this.$t("stock"),
        sortable: false,
        value: "stock",
      },
      {
        text: this.$t("orderPoint"),
        sortable: false,
        value: "order_point",
      },
      {
        text: this.$t("barcode"),
        sortable: false,
        value: "barcode",
      },
      {
        text: this.$t("variant-product"),
        sortable: false,
        value: "variants_count",
      },
      {
        text: this.$t("price"),
        sortable: false,
        value: "price",
      },
      {
        text: this.$t("other"),
        sortable: true,
        value: "content",
        table: "users.content",
      },
      {
        text: this.$t("tag"),
        sortable: false,
        value: "tags",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    this.printHeaders = [
      {
        text: this.$t("id"),
        value: "id",
      },
      {
        text: this.$t("code") + "" + this.$t("product"),
        value: "code",
      },
      {
        text: this.$t("name"),
        value: "name",
      },
      {
        text: this.$t("productKind"),
        value: "kind_id",
      },
      {
        text: this.$t("main-group"),
        value: "group.name",
      },
      {
        text: this.$t("other-group"),
        value: "cat1.name",
      },
      {
        text: this.$t("category"),
        value: "cat2.name",
      },
      {
        text: this.$t("barcode"),
        value: "barcode",
      },
      {
        text: this.$t("price"),
        value: "price",
      },
      {
        text: this.$t("stock"),
        value: "stock.count",
        sum: true,
        type: "number",
      },
    ];
    this.productStatusItems = [
      {
        value: "active",
        text: this.$t("active"),
      },
      {
        value: "deactive",
        text: this.$t("deactive"),
      },
    ];
    this.inventoryStatusItems = [
      {
        value: ">",
        text: this.$t("available"),
      },
      {
        value: "=",
        text: this.$t("unavailable"),
      },
      {
        value: "<",
        text: this.$t("negetive"),
      },
      {
        value: "orderpoint",
        text: this.$t("orderpoint"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
    reorderPinnedHeaders(this.headers, {
      locked: this.productListLockedColumns,
      anchor: "actions",
    });
    this.loadProductListColumnSettings();
  },
  mounted() {
    this.createGoogleCalendarLink({
      startDate: "20250115T083000Z",
      endDate: "20250115T093000Z",
      summary: "آلما جین - نرم افزار حسابداری",
      location: "سازیتو",
      description: "جلسه بررسی نرم افزار حسابداری",
    });
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.updateDesktopTableHeight();
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      });
    }
  },
  deactivated() {
    this.unbindListViewportObserver();
  },
  beforeDestroy() {
    this.unbindListViewportObserver();
    if (this.listViewportRaf) {
      cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = null;
    }
  },
  methods: {

    resetFilters() {
      var app = this;
      [
        "productStatus", "inventoryStatus", "tag", "group", "cat1", "cat2",
        "registerar", "branch", "bundling", "customFields",
      ].forEach(function (k) {
        app[k] = null;
      });
      if (app.inventoryStatusProp) {
        app.inventoryStatus = app.inventoryStatusProp;
      }
    },
    resolveRefEl(ref) {
      if (!ref) return null;
      return ref.$el || ref;
    },
    onResize() {
      if (this.isDesktopListViewport) {
        this.updateDesktopTableHeight();
        return;
      }
      this.tableHeight = window.innerHeight - 245;
    },
    scheduleDesktopTableHeightUpdate() {
      if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = requestAnimationFrame(() => {
        this.listViewportRaf = null;
        this.updateDesktopTableHeight();
      });
    },
    updateDesktopTableHeight() {
      if (!this.isDesktopListViewport) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const toolbarEl = this.resolveRefEl(this.$refs.listToolbar);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      if (!rootEl || !tableColEl) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootStyle = window.getComputedStyle(rootEl);
      const rootPadding =
        (parseFloat(rootStyle.paddingTop) || 0) +
        (parseFloat(rootStyle.paddingBottom) || 0);
      const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0;
      let summaryHeight = 0;
      if (summaryEl) {
        const summaryVisible =
          summaryEl.offsetParent !== null || summaryEl.getClientRects().length > 0;
        if (summaryVisible) {
          const summaryStyle = window.getComputedStyle(summaryEl);
          summaryHeight =
            summaryEl.offsetHeight +
            (parseFloat(summaryStyle.marginTop) || 0) +
            (parseFloat(summaryStyle.marginBottom) || 0);
        }
      }
      const colStyle = window.getComputedStyle(tableColEl);
      const colPadding =
        (parseFloat(colStyle.paddingTop) || 0) +
        (parseFloat(colStyle.paddingBottom) || 0);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      const footerHeight = footerEl ? footerEl.offsetHeight : 0;
      const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null;
      const tableMargins = tableStyle
        ? (parseFloat(tableStyle.marginTop) || 0) +
          (parseFloat(tableStyle.marginBottom) || 0)
        : 0;
      const available =
        rootEl.clientHeight -
        rootPadding -
        toolbarHeight -
        summaryHeight -
        colPadding -
        footerHeight -
        tableMargins -
        3;
      this.tableHeight = Math.max(180, Math.floor(available));
    },
    bindListViewportObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.unbindListViewportObserver();
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      if (!rootEl && !summaryEl && !tableColEl) return;
      this.listViewportObserver = new ResizeObserver(() => {
        this.scheduleDesktopTableHeightUpdate();
      });
      if (rootEl) this.listViewportObserver.observe(rootEl);
      if (summaryEl) this.listViewportObserver.observe(summaryEl);
      if (tableColEl) this.listViewportObserver.observe(tableColEl);
      if (footerEl) this.listViewportObserver.observe(footerEl);
    },
    unbindListViewportObserver() {
      if (this.listViewportObserver) {
        this.listViewportObserver.disconnect();
        this.listViewportObserver = null;
      }
    },
    loadProductListColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.productListColumnPersistKey).then(function (snapshot) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: app.productListLockedColumns,
          anchor: "actions",
        });
        app.$forceUpdate();
      });
    },
    //add goTovariants for specific product
    goToVariants(item) {
      this.$router.push({
        name: "Variants",
        params: { id: item.id },
      });
    },
    //add Updating Product Inventory
    upateProdyctInventory() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push({ id: value.id });
      });
      app.$axios
        .post(this.$endpoint + "product/update-in-integrators", {
          product_ids: selected.map((item) => item.id),
        })
        .then((res) => {
          res = res.data;
          app.getItems();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    //
    showInfo(item) {
      this.infoItem = item;
      this.infoDialog = true;
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    //add Integrator excel //
    openExcelDialog() {
      this.$refs.refIntegratorExcel.typeDialog = true;
    },
    getIntegratorPageRows() {
      if (this.skipIntegratorBeforeGenerate) return;
      return this.getIntegratorRows(this.tableOptions.page);
    },
    getIntegratorAllRows() {
      this.skipIntegratorBeforeGenerate = true;
      this.getIntegratorRows();
    },
    getIntegratorRows(onlyPage) {
      var app = this;
      var isPageMode = !!onlyPage;

      if (!isPageMode) {
        app.$refs.refIntegratorExcel.typeDialog = false;
        app.$refs.refIntegratorExcel.progressDialog = true;
      }

      app.integratorExcelItems = [];
      app.integratorExcelPage = isPageMode ? onlyPage : 1;

      var page = isPageMode ? onlyPage : 1;
      var lastPage = 1;

      function fetchPage() {
        return app.$axios
          .get(app.$endpoint + "product/with-integrators", {
            params: {
              options: app.tableOptions,
              page: page,
              search: app.search,
            },
          })
          .then(function (response) {
            var res = response.data;
            lastPage = res.last_page;
            app.integratorPageCount = lastPage;
            app.integratorExcelPage = page;

            res.data.forEach(function (item) {
              if (!item.integrator) return;
              app.integratorExcelItems.push({
                شناسه: item.id,
                نام: item.name,
                "یکپارچه ساز": item.integrator.type,
                "نام پنل": item.integrator.panel_name,
                DKP: item.integrator.integrator_product_id,
                DKPC: item.integrator.integrator_variant_id,
              });
            });
            if (isPageMode) return;
            if (page < lastPage) {
              page++;
              return fetchPage();
            }
            if (app.integratorExcelItems.length === 0) {
              app.skipIntegratorBeforeGenerate = false;
              app.$refs.refIntegratorExcel.progressDialog = false;
              return;
            }

            app.$refs.refIntegratorExcel.lang = "eng";
            return app.$refs.refIntegratorExcel.generate().then(function () {
              app.$refs.refIntegratorExcel.lang = "main";
              app.integratorExcelPage = 1;
              app.integratorExcelItems = [];
              app.skipIntegratorBeforeGenerate = false;
              app.$refs.refIntegratorExcel.progressDialog = false;
            });
          })
          .catch(function (err) {
            app.serverErrorHandeler(err);
            app.skipIntegratorBeforeGenerate = false;
            app.$refs.refIntegratorExcel.progressDialog = false;
          });
      }

      return fetchPage();
    },
    //
    openUploadDialog(type) {
      if (!this.$root) {
        return;
      }
      if (type == "data") {
        this.$root.$emit("open-user-file-process", { type: "product" });
      }
      if (type == "integrator") {
        this.$root.$emit("open-user-file-process", {
          type: "productIntegrator",
        });
      }
    },
    excelUpdatePrice(item) {
      if (this.$root) {
        this.$root.$emit("open-user-file-process", {
          type: "updateFixedPrice",
        });
      }
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      if (this.$route.name === "Variants" && this.$route.params.id) {
        this.$router.push({
          name: "ProductEdit",
          params: { id: this.$route.params.id },
          query: { "variant-id": item.id },
        });
        return;
      }
      if (this.$route.name === "VariantsList") {
        this.$router.push({
          name: "ProductEdit",
          params: { id: item.product_id },
          query: { "variant-id": item.id },
        });
        return;
      }
      this.$router.push({ name: "ProductEdit", params: { id: item.id } });
    },
    turnover(item, entrepot) {
      this.$router.push({
        name: "productTurnoverSingle",
        params: { id: item.id, entrepotProp: entrepot, tabName: item.name },
      });
    },
    entrepotTurnover(item, entrepot) {
      this.$router.push({
        name: "productPerEntrepotListSingle",
        params: { id: item.id, tabName: item.name },
      });
    },
    turnoverCount(item, entrepot) {
      this.$router.push({
        name: "productCountTurnover",
        params: {
          id: item.id,
          productProp: item,
          entrepotProp: entrepot,
          tabName: item.name,
        },
      });
    },
    turnoverAmount(item, entrepot) {
      this.$router.push({
        name: "productAmountTurnover",
        params: {
          id: item.id,
          productProp: item,
          entrepotProp: entrepot,
          tabName: item.name,
        },
      });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      if (this.inventoryStatusProp) {
        app.inventoryStatus = this.inventoryStatusProp;
        app.typeForm = "product";
      }
      app.$axios
        .get(this.$endpoint + "products", {
          params: {
            inventoryStatus: app.inventoryStatus,
            customFields: app.customFields,
            branch: app.branch,
            group: app.group,
            cat1: app.cat1,
            cat2: app.cat2,
            registerar: app.registerar,
            search: app.search,
            page: app.allRows ? app.excelPage : app.tableOptions.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.tableOptions,
            tag: app.tag,
            typeForm: app.typeForm,
            getVariants: app.getVariants,
            product_id: app.productId,
            bundling: app.bundling,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    openProductCard(item) {
      this.selectProduct = item;
      this.productCardDialog = true;
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "products/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    /* barcodeSingle (item) {
        this.$router.push({ name: 'productBarcode', params: { items: [item] } })
      },
      barcode () {
        this.$router.push({ name: 'productBarcode', params: { items: this.selected } })
      }, */
    barcodeSingle(item) {
      this.$router.push({ name: "labelPrintSetting", params: { items: [item] } });
    },
    barcode() {
      this.$router.push({ name: "labelPrintSetting", params: { items: this.selected } });
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push({ id: value.id });
      });
      app.$axios
        .post(this.$endpoint + "products/group-destroy", {
          deleteItems: selected.map((item) => item.id),
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    rebuildGoodCostItem(item) {
      this.selected.push(item);
      this.rebuildGoodCost();
    },
    async rebuildGoodCost() {
      if (await this.$refs.confirm.open("Confirm", this.$t("doYouSureForThisAction?"))) {
        var app = this;
        app.loading = true;
        var selected = [];
        app.selected.map(function (value, key) {
          selected.push(value.id);
        });
        app.$axios
          .get(this.$endpoint + "products", {
            params: {
              rebuildGoodCost: "active",
              items: selected,
            },
          })
          .then((res) => {
            res = res.data;
            app.snakbarText = this.$t("alertRebuildGoodCostnQueue");
            app.snakbarColor = "blue";
            app.snakbar = true;
            app.selected = [];
          })
          .catch((err) => {
            this.deletDialog = false;
            this.serverErrorHandeler(err);
          })
          .finally(() => (app.loading = false));
      }
    },
    calcPriceWithTax(item) {
      if (item.tax_percent && item.tax_percent > 0) {
        var TaxAmount = +item.price * (1 + +item.tax_percent / 100);
        return +this.roundMath(TaxAmount, this.$store.state.currency.decimal);
      }
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        // Use zero-width non-joiner or non-breaking space
        const barcodes =
          d.barcodes && d.barcodes.length > 0
            ? d.barcodes.map((item) => "\u200C" + String(item.value)).join(",")
            : "";

        const tags = d.tags.map((item) => item.text).join(",");
        const priceWithTax = app.calcPriceWithTax(d);
        app.excelItems.push({
          id: d.id,
          uid: d.uid,
          type: app.$t(d.type),
          name: d.name,
          kind: d.kind ? d.kind.name : "",
          code: d.code,
          barcode: d.barcode,
          branch_name: d.branch ? d.branch.name : "",
          group: d.group ? d.group.name : "",
          category: d.cat1 ? d.cat1.name : "",
          subcategory: d.cat2 ? d.cat2.name : "",
          tax_id: d.taxid,
          tax_percent: d.tax_percent,
          weight: d.weight,
          orderPoint: d.order_point,
          stock: d.stock ? d.stock.count : "",
          unit: d.unit ? d.unit.fame : "",
          unitId: d.unit ? d.unit.id : "",
          price: d.price,
          price_with_tax: priceWithTax,
          content: d.content,
          markito_id: d.integrator ? d.integrator.markitoId : null,
          woocommerce_id: d.integrator ? d.integrator.woocommerceId : null,
          woocommerce_variant_id: d.integrator ? d.integrator.woocommerceVariantId : null,
          portal_id: d.integrator ? d.integrator.portalId : null,
          portal_variant_id: d.integrator ? d.integrator.portalVariantId : null,
          webzi_id: d.integrator ? d.integrator.webziId : null,
          webzi_variant_id: d.integrator ? d.integrator.webziVariantId : null,

          digikala:
            d.digikala_product && d.digikala_product.length > 0
              ? d.digikala_product
                  .map(
                    (item) =>
                      item.panels?.name +
                      ":" +
                      item.digikala_product_id +
                      "," +
                      item.product_variant_id
                  )
                  .join(" | ")
              : null,

          sazito:
            d.sazito_product && d.sazito_product.length > 0
              ? d.sazito_product
                  .map(
                    (item) =>
                      item.panels?.name +
                      ":" +
                      item.sazito_id +
                      "," +
                      item.sazito_dynamic_id
                  )
                  .join(" | ")
              : null,

          display_priority: d.meta ? d.meta.priority : null,
          barcodes: barcodes,
          tags: d.tags ? tags : null,
          user: d.user ? d.user.name : "",
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
/* Desktop chrome: shared pro-list kit (slot content of ProListFrame) */
@import "~@/sass/design-system/list/pro-list";

/* Tighter rows: less cell padding and line height only — same layout. */
.pl ::v-deep .v-data-table tbody tr td {
  height: 30px !important;
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}
.pl ::v-deep .v-data-table tbody tr td .v-card__text,
.pl ::v-deep .v-data-table tbody tr td .text-caption {
  line-height: 1.2 !important;
}

::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
  width: auto;
}
::v-deep .v-input--selection-controls__ripple {
  width: auto;
  height: auto;
  margin: 0;
}
::v-deep .v-btn--icon.v-size--default {
  height: auto;
  width: auto;
}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd),
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even) {
  /* background-color: transparent !important; */
  height: 60px;
}
.v-card__text {
  width: auto;
}
.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
@media (max-width: 863px) {
  ::v-deep .v-data-table table tbody tr,
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(odd),
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(even) {
    height: auto;
  }
}
</style>
